import React from 'react';

const NoMicrophone = () => {
  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <h4>Microphone Access Required</h4>
      <p>Please allow microphone access to use this feature.</p>
    </div>
  );
};

export default NoMicrophone;